module.exports = __webpack_public_path__ + "img/shequbanner.8a6a554d.png";